import DOMPurify from "dompurify";
import { formatDate } from "../utils/portalHelpers";

/** "Version 2026.2 · Effective 1 Jul 2026", leaving out whatever the office did not set. */
export const termsCaption = (document) =>
  [
    document?.version ? `Version ${document.version}` : null,
    document?.effectiveFrom ? `Effective ${formatDate(document.effectiveFrom)}` : null,
  ]
    .filter(Boolean)
    .join(" · ");

/** The agreement text, sanitized: authored by the office, but still HTML from the server. */
const TermsDocument = ({ document, className = "" }) => (
  <div
    className={`partner-terms text-sm text-slate-700 leading-relaxed break-words ${className}`}
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(document?.html || "") }}
  />
);

export default TermsDocument;
